import { getMeta, testDynData, getDynDataOne } from "./general_functions"
import { getContactByEmail, setContactArticle } from "./contact_functions";
import { btiStep, btiLevel, btiClickActions, btiButton } from "./bti";


export const compileResources = (content, all) => {

    var test = $("<div class='article-parse'>" + content + "</div>"),
        ids = [],
        results = [];

    var btiLevelInsert = 0;
    var btiStepInsert = 0;

    var btiSteps = [];
    var btiLevels = [];

    test.find(".h-card").unwrap();

    // console.log("[compileResources]", content, all);

    test.find("span#editorBlokk > span").each(function() {

        var id = $(this).attr("id") || false;
        var that = $(this);


        if (id) {

            $.each(all, function(nr, obj) {

                // console.log("[compileResources each]", nr, obj, id, obj.contentId);
                if (id === obj.contentId) {
                    // console.log("[compileResources each match]")

                    // console.log("obj pageTypeId", obj.pageTypeId);

                    if (obj.pageTypeId === "mal_blokk") {
                        // console.log("[compilecontent: activity: mal_blokk]")
                        // console.log("[compileResources]", content);
                        let contentToDecode = obj.contentObject;
                        while ((contentToDecode.includes("%20") || contentToDecode.includes("%3C")) && decodeURIComponent(contentToDecode) != contentToDecode) {
                            contentToDecode = decodeURIComponent(contentToDecode);
                        }
                        var html = $(`<div class="blokk" data-id="${obj.contentId}" data-author="${obj.creator}">${contentToDecode}</div>`);

                        if (obj.relatedContentObjects) {
                            if (obj.relatedContentObjects.length > 0) {
                                // console.log("children", html.html());
                                let testing = compileResources(html.html(), obj.relatedContentObjects);

                                html.html(testing);
                            }
                        }
                        if (obj.relatedContents.length > 0 && obj.relatedContentObjects === null) {
                            console.warn("[ Har relatedContents, men ikke følgeobject i relatedContentObjects ]");
                        }
                    }
                    else if (obj.pageTypeId === "mal_visittkort" || (obj.pageTypeId === "mal_dynamisk")) {
                        // console.log("[compilecontent: activity: mal_visittkort // mal_dynamisk]")

                        let meta = getMeta(obj.metaObject);

                        meta.contentTypeId = meta.contentTypeId === undefined ? meta.id : meta.contentTypeId;

                        if (testDynData(meta, "localId", "9c49f83a-bd49-425b-8fbb-6b211c038391")) { // Dynamisk mal kontaktkort.

                            // console.log("obj ok test", obj);

                            let mail = getDynDataOne(meta, "9c49f83a-bd49-425b-8fbb-6b211c038391", "localId");


                            if (mail) {

                                // has mail. 
                                mail = mail.value;

                                var html = $(`<div class="blokk" data-id="${obj.contentId}" data-author="${obj.creator}">
                            <div class="spinner-border" role="status">
                              <span class="sr-only">Loading...</span>
                            </div></div>`);

                                // console.log("email, ", mail);

                                getContactByEmail(mail, function(data) {


                                    data = data[0];

                                    if (data) {

                                        var contact = setContactArticle({
                                            name: data.Name || false,
                                            email: data.Email || false,
                                            title: obj.title,
                                            phone: data.Mobile || false,
                                            about: decodeURIComponent(obj.contentObject),
                                            department: data.Subdivision || false
                                        });

                                    }

                                    $(`.blokk[data-id='${obj.contentId}']`).html(contact);

                                })

                            }



                        }
                        else if (meta.contentTypeId === "aa33f116-bb07-4a93-9a27-12bc38d88efb") {

                            btiLevels.push({ obj, meta });
                            // console.log("length ", $("[data-group=aa33f116-bb07-4a93-9a27-12bc38d88efb]"));
                            if (btiLevelInsert < 1) {
                                btiLevelInsert = 1;
                                html = $(`<div class="blokk bti__header" data-group="aa33f116-bb07-4a93-9a27-12bc38d88efb" data-id="${obj.contentId}" data-author="${obj.creator}"></div>`)
                            }

                        }
                        else if (meta.contentTypeId === "f63340c6-b3c3-49c0-b8c8-a661b55cd946") {

                            btiSteps.push({ obj, meta });
                            if (btiStepInsert < 1) {
                                btiStepInsert = 1;
                                html = $(`<div class="blokk bti__content" data-group="f63340c6-b3c3-49c0-b8c8-a661b55cd946" data-id="${obj.contentId}" data-author="${obj.creator}"></div>`)
                            }

                        }
                        else if (meta.contentTypeId === "c62f29ab-91e9-4aec-823a-80b4e0c99eef") { // Dynamisk mal BTI - Knapp
                            const link = getDynDataOne(meta, "10ec9d51-e156-44c1-9d20-f536e8323688", "localId").value;
                            var html = $(`<div class="blokk" data-id="${obj.contentId}" data-author="${obj.creator}"><div><a class="bti__button align-top" href="${link}"><h3>${obj.title}</h3><p>${obj.intro}</p></div>`);

                        }
                        else {

                            // console.log("meta", meta);

                            if (meta.personNavn) {

                                if (meta.personNavn.match(/^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/)) {
                                    var html = $(`<div class="blokk" data-id="${obj.contentId}" data-author="${obj.creator}">
                                <div class="spinner-border" role="status">
                                  <span class="sr-only">Loading...</span>
                                </div></div>`);

                                    getContactByEmail(meta.personNavn, function(data) {


                                        data = data[0];


                                        var contact = setContactArticle({
                                            name: data.Name || meta.personNavn || false,
                                            email: data.Email || meta.personEpost || false,
                                            title: meta.personStilling || false,
                                            phone: data.Mobile || meta.personMobil || false,
                                            about: meta.personFritekst || false,
                                            department: data.Subdivision || meta.personAvdeling || false
                                        });

                                        $(`.blokk[data-id='${obj.contentId}']`).html(contact);


                                    })
                                }
                                else {
                                    // console.log("compile data", meta);

                                    var contact = setContactArticle({
                                        name: meta.personNavn || false,
                                        email: meta.personEpost || false,
                                        title: meta.personStilling || false,
                                        wiredPhone: meta.personTelefon || false,
                                        phone: meta.personMobil || false,
                                        about: meta.personFritekst || false,
                                        department: meta.personAvdeling || false,
                                        image: meta.imageContentId || false
                                    });

                                    var html = $(`<div class="blokk" data-id="${obj.contentId}" data-author="${obj.creator}">${contact}</div>`);
                                }
                            }

                        }

                    }
                    else if (obj.pageTypeId === "mal_dynamisk") {

                        // console.log("[compilecontent: activity: mal_dynamisk]")
                        // console.log("mal_dyn");

                    }
                    else {
                        // console.log("No template", obj);

                        // console.log("[compilecontent: activity: else]")
                        that.parent().replaceWith("")

                    }

                    that.parent().replaceWith(html);
                }
            });

            // let nothing = all;

            let working = all.filter((obj) => {

                return (obj.contentId === id ? obj : false)

            });

            // console.log(all);


            if (working.length < 1) {
                // console.log(id, "dead subs", all, working);

                console.warn("[Has blokkcontent with Id but not content - removeing container: " + that.parents(".h-card").text() + " ]");
                that.parents(".h-card")
                    .addClass("toberemoved")
                    .prevUntil("h1,h2,h3,h4,h5,h6")
                    .addBack()
                    .prev("h1,h2,h3,h4,h5,h6")
                    .addBack()
                    .wrapAll("<div class='is_removed'><div class='removeable_group'></div></div>");

                if (that.parents(".removeable_group").find(".h-card:not(.toberemoved)").length < 1) {
                    that.parents(".removeable_group").remove();
                }
                else {
                    that.parents(".removeable_group").find(".toberemoved").remove();
                }


            }




        }


    });


    // console.log("test", test);

    // test.find(".temparticle").unwrap();

    if (btiLevels.length > 0 && btiSteps.length > 0) {

        // console.log(btiLevels);

        let levels = btiLevel(btiLevels);

        // console.log("levels",html);

        test.find('[data-group="aa33f116-bb07-4a93-9a27-12bc38d88efb"]').append(levels);


        let steps = btiStep(btiSteps, test);
        test.find('[data-group="f63340c6-b3c3-49c0-b8c8-a661b55cd946"]').append(`<div class="d-none d-sm-block bti__steps__container">${steps}</div>`);



    }

    btiClickActions();


    return test.html();


}

export const insertSegments = (content) => {



    var wrapper = $("<div class='article-parse'><div class='pretest'>" + content + "</div></div>");


    let i = 0;

    // wrapper.find("h2").each(function(){
    //   if($(this).text() === "&nbsp;"){
    //       $(this).remove();
    //   } 
    // });

    // // wrapper.find(".pretest > .h-card").each(function(){

    //   $(this).prevUntil("h2,h3").addBack().prev('h2,h3').addBack().wrapAll("<div class='article__group'></div>");
    //   i++;

    // });

    wrapper.find(".pretest h2, .pretest h3").each(function() {

        $(this).addBack().nextUntil("h2,h3").addBack().wrapAll(`<div class="article__group test"></div>`)

    })
    // console.log(i);


    return wrapper.find(".pretest").html();

}

export const checkSingleLinks = (content) => {

    var wrapper = $("<div class='article-parse'>" + content + "</div>");

    wrapper.find("p:has(a)").filter(function() {
        return $(this).contents().length === 1;
    }).children('a').addClass("possible__button");

    wrapper.find("a.simple-button-plugin").filter(function() {
        return this.style["background-color"] == "black" || this.style["background-color"] == "#000000" || this.style["background-color"] == "rgb(0, 0, 0)";
    }).addClass("primary__button");
    wrapper.find("a.simple-button-plugin").removeAttr('style');

    return wrapper.html();

}
